var module = angular.module('components');
module.component('navigationNode', {
    templateUrl: 'components/navigation/navigationNode.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        node: '<',
        level: '<',
        claims: '<',
        root: '<',
        branch: '<',
        licenseModules: '<'
    },
    controller: ['$state','AuthService','$window','$rootScope', '$translate',controller]
});


function controller($state, AuthService, $window, $rootScope, $translate)  {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;
    vm.onClick = onClick;
    vm.hasFocus = hasFocus;
    vm.shouldRender = shouldRender;
    vm.getIndentation = getIndentation;
    vm.getNodeLabel = getNodeLabel;

    function onInit() {
        vm.node.expanded = false;
    }

    function onChanges(changes) {
    }

    function onDestroy() {
    }

    function onClick() {
        if (vm.node.stateLink) {
            $rootScope.$emit('NavigatingTo', vm.node.stateLink);
            $state.go(vm.node.stateLink, vm.node.params == undefined ? {} : vm.node.params);
            $window.scrollTo(0, 0);
            return;
        }
        toggleMenuExpansion();
    }

    function hasFocus() {
        if (vm.node.stateLink) {
            if ($state.includes(vm.node.stateLink)) {
                 return true;
            }
        }
        return false;
    }

    function shouldRender(type) {
        if (type === 'root' && vm.level > 0) {
            return false;
        }

        if (type === 'leaf' && vm.level === 0) {
            return false;
        }

        if (vm.node.claims && !AuthService.matchAnyDemand(vm.node.claims, vm.claims)) {
            return false;
        }

        if (vm.node.licenseModules && !AuthService.matchAnyDemand(vm.node.licenseModules, vm.licenseModules)) {
            return false;
        }

        if (vm.node.claims && !AuthService.matchTwoDemand(vm.node.claims, vm.claims, type, "seepurchasecost", "stock")) {
            return false;
        }

        if (vm.node.devFeature && localStorage.getItem(vm.node.devFeature) !== 'true') {
            return false;
        }

        return true;
    }

    function getNodeLabel(node) {
        var label = _.map(node.label, function(o) {
            return $translate.instant(o);
        });

        var text = _.join(label, ' ');

        if (node.reactPreviewFeature && localStorage.getItem(node.reactPreviewFeature) === 'true') {
            text += ' (new)';
        }

        return text;
    }

    function getIndentation(level) {
        if (level > 1) {
            return Array(level).join('-') + ' ';
        }
        return '';
    }

    function toggleMenuExpansion() {
        vm.node.expanded = !vm.node.expanded;

        if (vm.node.expanded) {
            _.forEach(vm.root.nodes, function(branch) {
                if (branch !== vm.branch) {
                    branch.expanded = false;
                }
            });

        }
    }

}
